import { render, staticRenderFns } from "./LeaderboardTitle.vue?vue&type=template&id=1d213084&scoped=true&"
import script from "./LeaderboardTitle.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTitle.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTitle.vue?vue&type=style&index=0&id=1d213084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d213084",
  null
  
)

export default component.exports